var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMeditationIconinline = function SvgMeditationIconinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%",
    id: "da"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9191FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F075C7",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15 7.824c-3.957 0-7.176 3.22-7.176 7.177 0 3.957 3.22 7.175 7.177 7.175 3.956 0 7.175-3.218 7.175-7.175S18.957 7.824 15 7.824m0 19.52c-6.807 0-12.345-5.537-12.345-12.342 0-6.807 5.538-12.346 12.345-12.346 6.806 0 12.343 5.539 12.343 12.346 0 6.805-5.537 12.342-12.343 12.342",
    id: "db"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "url(#da)",
    cx: 32.5,
    cy: 32.5,
    r: 32.5
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#db",
    transform: "translate(18 18)"
  }))));
};
export default SvgMeditationIconinline;